import React from 'react';
import styles from '@/components/help/common/FormContainer/FormContainer.module.scss';
import {ControllerWrapper} from '@/components/common';
import {SoopInputBox} from '@soop-ui/soop-ui';
import {FORM_FIELDS} from '@/constants/help/index';
import {handleNumericInput} from '@/utils/help/formUtils';
import {useFormClear} from '@/hooks/help/useFormClear';
import {useFormKeyHandler} from '@/hooks/help/useFormKeyHandler';

const BIRTH_PLACEHOLDER = '숫자로만 입력';

const Birth = () => {
  const {handleClear} = useFormClear();
  const {handleFormKeyDown} = useFormKeyHandler();

  const onClear = () => handleClear(FORM_FIELDS.BIRTH, {shouldFocus: true});

  return (
    <div className={`${styles.section}`}>
      <label className={styles.label}>{`생년월일(기관·법인번호)`}</label>
      <ControllerWrapper
        component={SoopInputBox}
        needsBlurWrapper={true}
        clearable={true}
        onClear={onClear}
        size='44'
        name={FORM_FIELDS.BIRTH}
        placeholder={BIRTH_PLACEHOLDER}
        onInput={handleNumericInput}
        inputMode='numeric'
        pattern='[0-9]*'
        onKeyDown={(e) => {
          handleFormKeyDown(e);
        }}
      />
    </div>
  );
};

export default Birth;
